// Marketing: contenedor con sub-navegación (réplica funcional de Clientify, sin chatbots ni videos).
import type { JSX } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { ClipboardList, FileText, Filter, Globe, LayoutDashboard, type LucideIcon, Mail, Users, Workflow } from "lucide-react";

const TABS: Array<{ to: string; label: string; icon: LucideIcon }> = [
  { to: "/marketing", label: "Dashboard", icon: LayoutDashboard },
  { to: "/marketing/contactos", label: "Contactos", icon: Users },
  { to: "/marketing/campanas", label: "Campañas", icon: Mail },
  { to: "/marketing/landings", label: "Landing pages", icon: Globe },
  { to: "/marketing/automatizaciones", label: "Automatizaciones", icon: Workflow },
  { to: "/marketing/formularios", label: "Formularios", icon: FileText },
  { to: "/marketing/encuestas", label: "Encuestas", icon: ClipboardList },
  { to: "/marketing/embudos", label: "Embudos", icon: Filter },
];

export function MarketingLayout(): JSX.Element {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <h1 className="page-title">Marketing</h1>
      </div>
      <nav className="subnav">
        {TABS.map((t) => {
          const Icon = t.icon;
          return (
            <NavLink key={t.to} to={t.to} end={t.to === "/marketing"} onClick={(e) => e.currentTarget.blur()}
              className={({ isActive }) => (isActive ? "actual" : "")}>
              <span className="sn-ico"><Icon size={15} strokeWidth={1.9} /></span>{t.label}
            </NavLink>
          );
        })}
      </nav>
      <Outlet />
    </div>
  );
}
